import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getCheckoutUrl } from 'layouts/pages/pricing-page/components/stripePayments';
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import Card from "@mui/material/Card";
import OutlinedCard from 'layouts/ecommerce/referral/components/OutlinedCard';
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import { useNavigate } from 'react-router-dom'; 
import SoftBadge from 'components/SoftBadge';
import Swal from "sweetalert2";


const NotLoggedIn = () => {
  

  const auth = getAuth();

  
  

  return (

  <SoftBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={3}>
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={12} lg={10}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={2} >
          <SoftTypography variant="h5" color="text" >
            👋 You are not logged in! 
          </SoftTypography>
          <SoftTypography sx={{mt: 2}} variant="h6" color="text" >
            Sign-In Required.
          </SoftTypography>
        </SoftBox>
      </Grid>
      

      {/*<Grid item xs={12} lg={10}>
        <SoftBox
          p={3}
          sx={{
            background: "white",
            borderRadius: '12px',
            boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.1)'
          }}
        >
          <Grid container spacing={3} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={9}>
              <SoftBox display="flex" flexDirection="column" alignItems="start">
                <SoftTypography variant="h4" fontWeight="bold">
                  Explore Yourself
                </SoftTypography>
                <SoftTypography variant="body1" color="text" >
                  Find out why professionals use Optimind-AI
                </SoftTypography>
              </SoftBox>
            </Grid>
            <Grid item xs={12} md={3}>
              <SoftBox display="flex" justifyContent="flex-end">
                <SoftButton onClick={() => startFreeTrial('price_1OXrlbKxgzsnLLGWIqBpKDWt')} variant="contained" color="dark" size="medium">
                  Start Trial
                  <Icon sx={{ marginLeft: 1 }}>arrow_forward</Icon>
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" alignItems="center" >
            <SoftBox pt={5} textAlign="center">
              <SoftBadge
                  variant="contained"
                  color="secondary"
                  size="sm"
                  sx={{ 
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    }
                  }}
                  badgeContent={
                    <SoftTypography 
                      variant="h6" 
                      color="dark" 
                      onClick={navigateToPricing}
                    >
                      Explore all subscription plans 
                    </SoftTypography>
                  }
                  circular
                  container
              />
              
            </SoftBox>
          </Grid>
        </SoftBox>
                </Grid>*/}
    </Grid>
    </SoftBox>

  );
};

export default NotLoggedIn;
